'use client'

import React from 'react'
import { Divider, Text } from '../../../atoms'
import { TextTypes } from '../../../../types'

export interface ContextMenuDividerProps {
    /** Translated string */
    label?: React.ReactNode
}

export const ContextMenuDivider = ({ label }: ContextMenuDividerProps) => {
    return (
        <div className="pt-3" role="separator">
            {label && (
                <Text className="ml-6 text-text-tertiary" type={TextTypes.HEADING_6}>
                    {label}
                </Text>
            )}
            <Divider />
        </div>
    )
}
